import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Typography } from "@mui/material";

export const StyledDashboard = styled.section`
  background-color: ${({theme}) => theme.colors.background};
  overflow-y: auto;
  height: 100%;
  
  .greeting {
    font-weight: 300;
    padding-bottom: 19px;
    color: ${({ theme }) => theme.colors.textColor};
  }

  @media ${deviceSpec.isTablet} {
    max-width: 100vw;
    padding: 0;
    .greeting {
      padding: 20px 0 20px 20px;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;

export const StyledTitle = styled(Typography)`
    @media ${deviceSpec.isTablet} {
      margin: 5px 0 5px 30px !important;
    }

    @media ${deviceSpec.isMobile} {
      margin: 5px 0 5px 15px !important;
    }
`;